var render, staticRenderFns
import script from "./FeatureUpgrade.vue?vue&type=script&lang=js"
export * from "./FeatureUpgrade.vue?vue&type=script&lang=js"
import style0 from "./FeatureUpgrade.vue?vue&type=style&index=0&id=0f883ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f883ca2",
  null
  
)

export default component.exports